/**
 * CONSAI — Signup Success Popup (dark glassmorphism, green glow)
 */
import React, { useEffect, useState } from 'react';
import { X, PartyPopper } from 'lucide-react';
import { trackSignup } from '../utils/metaPixel';

const SignupSuccessPopup = ({ show, onClose }) => {
  const [visible, setVisible] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (show) {
      trackSignup();
      setVisible(true);
      setFadeOut(false);
      const timer = setTimeout(() => { handleClose(); }, 5000);
      return () => clearTimeout(timer);
    }
  }, [show]);

  const handleClose = () => {
    setFadeOut(true);
    setTimeout(() => { setVisible(false); onClose?.(); }, 300);
  };

  if (!visible) return null;

  return (
    <div
      className={`fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[90%] max-w-xl transition-all duration-300 ${fadeOut ? 'opacity-0 -translate-y-4' : 'opacity-100 translate-y-0'}`}
      data-testid="signup-success-popup"
    >
      <div
        className="relative p-4 md:p-5 rounded-2xl overflow-hidden"
        style={{
          background: 'rgba(20, 20, 22, 0.85)',
          backdropFilter: 'blur(18px)',
          WebkitBackdropFilter: 'blur(18px)',
          border: '1.5px solid rgba(74, 222, 128, 0.55)',
          boxShadow: '0 0 32px rgba(74, 222, 128, 0.25), 0 12px 36px rgba(0, 0, 0, 0.55)',
        }}
      >
        <div
          className="absolute inset-0 rounded-2xl pointer-events-none"
          style={{ background: 'linear-gradient(135deg, rgba(74, 222, 128, 0.10) 0%, transparent 55%, rgba(74, 222, 128, 0.06) 100%)' }}
        />
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 p-1.5 rounded-full bg-white/5 hover:bg-white/10 transition-colors"
          aria-label="Close"
          data-testid="close-signup-popup"
        >
          <X className="h-4 w-4 text-white/60" />
        </button>
        <div className="flex items-start gap-4 pr-8 relative">
          <div
            className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
            style={{
              background: 'linear-gradient(135deg, rgba(74, 222, 128, 0.25) 0%, rgba(34, 197, 94, 0.35) 100%)',
              border: '1px solid rgba(74, 222, 128, 0.45)',
            }}
          >
            <PartyPopper className="h-6 w-6 text-green-400" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-white tracking-tight mb-1">
              Welcome to CONSAI!
            </h3>
            <p className="text-white/65 text-sm md:text-base">
              Your 14-day Premium trial has started. Explore all features now.
            </p>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-white/5 rounded-b-2xl overflow-hidden">
          <div className="h-full bg-gradient-to-r from-green-400 to-emerald-500" style={{ animation: 'shrink 5s linear forwards' }} />
        </div>
      </div>
      <style>{`@keyframes shrink { from { width: 100%; } to { width: 0%; } }`}</style>
    </div>
  );
};

export default SignupSuccessPopup;
